import { AccredibleAuthenticationApiService } from '@accredible-frontend-v2/services/authentication';
import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SmartResumeLoginService } from '../../application/smart-resume/smartresume-login.service';
import * as AuthorizedActions from '../../infrastructure/stores/authorized';
import { AuthorizedState } from '../../infrastructure/stores/authorized';

export const smartResumeLoginRedirect: CanActivateFn = (): Observable<boolean> => {
  const authorizedStore = inject(Store<AuthorizedState>);
  const authenticationApi = inject(AccredibleAuthenticationApiService);
  const userApi = inject(AccredibleUserApiService);
  const smartResume = inject(SmartResumeLoginService);

  const sessionToken = authenticationApi.getSessionToken();

  if (!smartResume.isSmartResume() || !sessionToken) {
    return of(true);
  }

  const user = userApi.getUser();
  if (user) {
    smartResume.redirectToCredentialShare(user.username, sessionToken);
    return of(false);
  }

  return authenticationApi.checkSession().pipe(
    tap((user) => authorizedStore.dispatch(AuthorizedActions.setUser({ user }))),
    tap((user) => smartResume.redirectToCredentialShare(user.username, sessionToken)),
    map(() => false),
  );
};
